import React from 'react';

function PlaceholderPersonIcon(props) {
  return (
    <svg
      width="420"
      height="420"
      viewBox="0 0 420 420"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M375 209C375 300.127 301.127 374 210 374C118.873 374 45 300.127 45 209C45 117.873 118.873 44 210 44C301.127 44 375 117.873 375 209ZM316.844 222.176C321.944 187.703 324.73 120.074 298.4 97.4592C264.236 68.1172 233.641 62.7112 197.176 65.9015C154.153 69.6655 128.733 81.6912 112.611 107.1L110.609 111.483C110.609 111.483 105.673 112.667 103.036 115.286C81.0329 142.128 95.2476 207.585 106.236 240.601C106.95 242.745 109.047 244.083 111.298 243.886C111.332 243.883 111.367 243.88 111.401 243.876C121.128 299.935 146.076 360.613 223.851 353.808C297.984 347.323 313.542 282.727 314.565 225.595C315.766 224.867 316.628 223.64 316.844 222.176Z"
        fill="black"
        fillOpacity="0.05"
      />
      <path
        d="M72.7341 77.528C75.2828 79.3659 78.4222 76.2266 76.5843 73.6778L62.1847 53.7088C59.74 50.3186 54.8505 49.9112 51.909 52.8527C48.9675 55.7942 49.3748 60.6837 52.7651 63.1284L72.7341 77.528Z"
        fill="black"
        fillOpacity="0.05"
      />
      <path
        d="M73.5249 88.9995C75.765 88.6347 75.765 85.4127 73.5249 85.0479L55.9741 82.1899C52.9943 81.7047 50.2894 84.0047 50.2894 87.0237C50.2894 90.0427 52.9943 92.3427 55.9741 91.8575L73.5249 88.9995Z"
        fill="black"
        fillOpacity="0.05"
      />
      <path
        d="M89.022 75.8948C88.7302 77.6872 86.152 77.6872 85.8602 75.8948L83.5733 61.8514C83.185 59.4671 85.0255 57.3027 87.4411 57.3027C89.8567 57.3027 91.6972 59.4671 91.3089 61.8513L89.022 75.8948Z"
        fill="black"
        fillOpacity="0.05"
      />
      <path
        d="M314.563 225.589C313.929 225.974 313.201 226.22 312.423 226.288C309.703 226.526 307.304 224.513 307.066 221.793L303.414 180.049C293.795 170.897 290.091 148.149 289.442 137.919C277.416 140.44 244.904 146.224 211.069 149.184C185.238 151.444 147.971 145.112 126.696 133.813C127.411 145.203 119.84 186.347 112.138 196.784L115.79 238.528C116.025 241.213 114.066 243.585 111.398 243.874C121.126 299.933 146.073 360.612 223.849 353.808C297.984 347.322 313.54 282.723 314.563 225.589Z"
        fill="black"
        fillOpacity="0.2"
      />
      <path
        d="M110.609 111.483C108.222 111.539 105.673 112.667 103.036 115.286C81.0329 142.129 95.2475 207.585 106.236 240.601C106.95 242.745 109.047 244.083 111.298 243.887C114.018 243.649 116.031 241.25 115.793 238.53L112.141 196.786C119.843 186.349 127.414 145.202 126.698 133.814C115.094 127.652 108.247 120.012 110.609 111.483Z"
        fill="black"
        fillOpacity="0.6"
      />
      <path
        d="M298.395 97.459C324.726 120.074 321.94 187.703 316.84 222.176C316.509 224.411 314.676 226.093 312.426 226.29C309.705 226.528 307.307 224.516 307.069 221.795L303.417 180.051C293.798 170.9 290.094 148.151 289.445 137.921C277.419 140.443 244.907 146.226 211.072 149.186C168.778 152.887 95.8241 133.552 112.607 107.1C128.728 81.691 154.149 69.6653 197.172 65.9012C233.637 62.711 264.232 68.117 298.395 97.459Z"
        fill="black"
        fillOpacity="0.6"
      />
    </svg>
  );
}

export default PlaceholderPersonIcon;
